import React from 'react';
import clsx from 'clsx';

/** Where the strip sits, which is all that changes between the two. */
const VARIANTS = {
  /** First child of the listing card, divided from the table by its border. */
  card: 'p-4 border-b border-border',
  /** Loose on the page background, the way `/deliveries` lays out its filters. */
  bare: '',
};

/**
 * The strip above a table: filters on the left, secondary actions on the right.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The filters.
 * @param {React.ReactNode} [props.actions]
 * @param {'card'|'bare'} [props.variant='card']
 * @param {string} [props.testId='filter-bar']
 */
export const FilterBar = ({ children, actions, variant = 'card', testId = 'filter-bar' }) => (
  <div
    data-testid={testId}
    className={clsx(
      'flex flex-col lg:flex-row lg:items-center justify-between gap-4',
      VARIANTS[variant] ?? VARIANTS.card
    )}
  >
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 flex-1 min-w-0">{children}</div>
    {actions && <div className="flex items-center gap-3">{actions}</div>}
  </div>
);
